import { Box, Button, Grid, Grow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ListIcon from '@mui/icons-material/List';
import { LargeModal } from '../../CustomModal/LargeModal';
import { ListOfGames } from './modal/ListOfGames';
import toast from 'react-hot-toast';
import { getGameResults } from './AdminMenusRequests';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { orange, red, yellow } from '@mui/material/colors';
import { ListOfGroups } from './modal/ListOfGroups';
import { styled } from '@mui/material/styles';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
export const Games = () => {
    const [listOfGames,setListOfGames] = useState([]);
    const [listOfGroups,setListOfGroups] = useState([]);
    useEffect(()=>{
        _init();
    },[])
    const _init = async () => {
        const toastId = toast.loading('Retrieving Game Results');
        const res = await getGameResults()
        setListOfGames(res.data.games)
        setListOfGroups(res.data.data)
        toast.success(res.data.message,{
            id:toastId
        })
    }
    const [openModal,setOpenModal] = useState(false);
    const [openGroupModal,setOpenGroupModal] = useState(false)
    const checkExists = (item,item2) => {
        if(item.id === item2.group_id){
            return (
                <TableCell key = {item2.id} align='center'>
                    <EmojiEventsIcon sx={{color:yellow[800]}}/>
                </TableCell>
            )
        }else{
            return (
                <TableCell key = {item2.id}>
                    
                </TableCell>
            )
        }
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between'}}>
                <Box sx={{width:'100%'}}>
                    <Typography variant='h5' className='game-font' sx={{textAlign:'center',textTransform:'uppercase',color:orange[800]}}>Scoreboard</Typography>
                </Box>
                <Box sx={{display:'flex',gap:1}}>
                    <Tooltip title='View List of Games'><Button variant='outlined' size='small' startIcon={<ListIcon/>} onClick = {()=>setOpenModal(true)}>Games</Button></Tooltip>
                    <Tooltip title='View List of Groups'><Button variant='outlined' size='small' startIcon={<ListIcon/>} onClick={()=>setOpenGroupModal(true)}>Groups</Button></Tooltip>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Grow in>
                    <Paper>
                        <TableContainer sx={{maxHeight:'70dvh'}}>
                            <Table stickyHeader  className='game-font'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Group Name
                                        </TableCell>
                                        <TableCell align='center'>
                                            Total Winnings
                                        </TableCell>
                                        {
                                            listOfGames.map((item)=>
                                                <TableCell key={item.id} align='center'>{item.game_name}</TableCell>
                                            )
                                        }
                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listOfGroups.map((item)=>
                                        <StyledTableRow key={item.id} sx={{background:item.rank===1 && item.total_win !==0?'#caf8ff !important':'auto'}}>
                                            <TableCell>
                                                {item.group_name}
                                            </TableCell>
                                            <TableCell align='center'>
                                                {item.total_win}
                                            </TableCell>
                                            {
                                                listOfGames.map((item2)=>
                                                    checkExists(item,item2)
                                                )
                                            }
                                        </StyledTableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <LargeModal open = {openModal} close = {()=>setOpenModal(false)} clickOutside={true} >
                <ListOfGames close = {()=>setOpenModal(false)} updateScoreBoard={_init}/>
            </LargeModal>
            <LargeModal open = {openGroupModal} close = {()=>setOpenGroupModal(false)} clickOutside={true} >
                <ListOfGroups close = {()=>setOpenGroupModal(false)} updateScoreBoard={_init}/>
            </LargeModal>
        </Grid>
    )
}